import tw, { styled } from 'twin.macro'

export const ExpandableAndCollapseContainer = styled.div`
   .ReactCollapse--collapse {
      transition: height 300ms;
      ${props => props.collapseClassName}
   }
`
